import React from 'react';
import { useIntl } from 'react-intl';
import { MdAdd } from 'react-icons/md';
import { CreateCard, CreateHint, CreateIcon, CreateTitle } from './CreateAppCard.styled';

interface CreateAppCardProps {
  readonly onClick: () => void;
}

const CreateAppCard: React.FC<CreateAppCardProps> = ({ onClick }) => {
  const intl = useIntl();
  return (
    <CreateCard type="button" onClick={onClick} data-testid="apps-gallery__create">
      <CreateIcon aria-hidden="true">
        <MdAdd size={26} />
      </CreateIcon>
      <CreateTitle>
        {intl.formatMessage({ id: 'apps.builder.create.title', defaultMessage: 'Create your app' })}
      </CreateTitle>
      <CreateHint>
        {intl.formatMessage({
          id: 'apps.builder.create.hint',
          defaultMessage: 'Describe the job and the assistant builds the app with you.',
        })}
      </CreateHint>
    </CreateCard>
  );
};

export default CreateAppCard;
